// 'tournament' 영역 문구 (토너먼트 관리 / 공개 대진표 / 전광판). 키는 ko / en 에 똑같이 둔다.
const tournament = {
  ko: {
    selector: {
      title: '대회 선택',
    },
    selectPrompt: '대회를 선택하면 대진표가 표시됩니다.',
    errors: {
      noTournaments: '등록된 대회가 없습니다.',
      loadTournaments: '대회 목록을 불러오지 못했습니다.',
      noParticipants: '대진표를 만들 참가자가 없습니다.',
      loadParticipants: '참가자 목록을 불러오지 못했습니다.',
      loadBracket: '대진표를 불러오지 못했습니다.',
      saveBracket: '대진표를 저장하지 못했습니다.',
      startMatch: '경기를 시작하지 못했습니다.',
      endMatch: '경기를 종료하지 못했습니다.',
      finalize: '결과를 확정하지 못했습니다.',
      reopen: '확정을 해제하지 못했습니다.',
    },
    meta: {
      date: '개최일',
      venue: '장소',
      format: '방식',
      event: '종목',
      eventName: '버추얼 태권도',
      status: '상태',
      finished: '결과 확정',
      inProgress: '진행 중',
    },
    mode: {
      single: '단판 토너먼트',
      gender: '남녀 분리 토너먼트',
      height: '키별 분리 토너먼트',
      matches: '1:1 경기',
      matchesGender: '1:1 경기 (남녀 분리)',
      matchesHeight: '1:1 경기 (키별 분리)',
    },
    stats: {
      total: '총 참가자',
      maleFemale: '남자 / 여자',
      avgHeight: '평균 신장',
      gyms: '참여 도장',
      gymCount: '{count}개',
    },
    admin: {
      title: '토너먼트 관리',
      descBefore: '대진 편집, 경기별 점수 입력, 결과 확정을 하는 관리자 화면입니다. 일반 공개 화면은',
      descAfter: ' 입니다.',
      selectedTournament: '선택된 대회',
      loadingParticipants: '참가자 정보를 불러오는 중...',
      loadingBracket: '저장된 대진표를 불러오는 중...',
      notEnoughParticipants: '대진표를 만들려면 참가자가 2명 이상 필요합니다. (현재 {count}명)',
      participantDiffNotice:
        '저장된 대진표와 참가자 구성이 다릅니다. (새 참가자 {added}명 / 취소 {removed}명) ' +
        '새 참가자를 대진에 넣으려면 「대진표 초기화」를 눌러 주세요.',
      participantDiffNoticeMatches:
        '저장된 경기와 참가자 구성이 다릅니다. (새 참가자 {added}명 / 취소 {removed}명) ' +
        '새 참가자의 경기는 「대진 편집」에서 「자동 짝 추가」나 「경기 추가」로 만들 수 있습니다.',
      hint: {
        edit: '대진 방식을 선택하고, 첫 라운드 참가자를 두 명 차례로 클릭해 순서를 바꿀 수 있습니다.',
        editMatches: '경기마다 선수를 바꾸거나, 순서를 옮기거나, 삭제할 수 있습니다. 같은 학생이 여러 번 경기해도 됩니다.',
        finished: '결과가 확정되어 회원 대회기록에 반영되었습니다. 수정하려면 「확정 해제」를 눌러 주세요.',
        default:
          '「점수 입력」으로 경기별 머리·몸통·최종점수와 승자를 기록하세요. 선수를 클릭해 승자만 지정할 수도 있습니다.',
      },
      saveState: {
        saving: '저장 중...',
        saved: '서버에 저장됨',
        synced: 'VR 기기 등 다른 곳에서 들어온 결과를 반영했습니다',
      },
      buttons: {
        resultsFinalized: '결과 확정됨',
        reopen: '확정 해제',
        openDisplay: '전광판 열기',
        editBracket: '대진 편집',
        resetBracket: '대진표 초기화',
        resetMatches: '자동 짝 다시 만들기',
        finalize: '결과 확정',
        finalizing: '확정 중...',
      },
      finalizeDisabledTitle: '모든 부문의 결승 승자를 정하면 확정할 수 있습니다.',
      finalizeDisabledTitleMatches: '모든 경기의 승자를 정하면 확정할 수 있습니다. (하지 않을 경기는 삭제)',
      editBanner: '편집 모드 · 참가자 클릭으로 1라운드 순서 변경',
      editBannerMatches: '편집 모드 · 1:1 경기 목록 수정',
      editBannerSelectSecond: ' (두 번째 참가자를 선택하세요)',
      formatGroupLabel: '경기 방식',
      formatOptions: {
        tournament: '토너먼트',
        matches: '1:1 경기 (여러 번)',
      },
      modeGroupLabel: '대진 방식',
      modeOptions: {
        combined: '통합 대진',
        gender: '남녀 분리 대진',
        height: '키별 분리 대진',
      },
      scoreModalTitle: '{no}번 경기 · {round}',
      confirm: {
        switchLiveMatch: '{court}코트에서 진행 중인 경기({no}번 {round})를 종료하고 이 경기를 시작할까요?',
        endLiveMatch:
          '{court}코트 경기를 종료할까요? VR에서 더 이상 이 경기로 점수를 보낼 수 없습니다. (입력된 점수는 남습니다)',
        changeMode: '대진 방식을 변경하면 대진표가 다시 생성되고 진행 기록이 초기화됩니다.\n계속하시겠습니까?',
        changeFormat: '경기 방식을 변경하면 대진표가 다시 생성되고 진행 기록이 초기화됩니다.\n계속하시겠습니까?',
        resetMatches:
          '1:1 경기를 자동으로 다시 짝짓습니다. 지금 경기 목록과 점수·승패 기록이 모두 초기화됩니다.\n계속하시겠습니까?',
        reset:
          '대진표를 초기화하면 1라운드 대진이 다시 랜덤으로 배정되고, 진행 중인 승자 기록도 모두 초기화됩니다.\n계속하시겠습니까?',
        finalize:
          '대진 결과를 확정하시겠습니까?\n확정하면 순위와 전적이 회원 대회기록에 저장되고, 확정을 해제하기 전까지 대진표를 수정할 수 없습니다.',
        finalizeMatches:
          '경기 결과를 확정하시겠습니까?\n확정하면 선수별 전적과 점수가 회원 대회기록에 저장되고(순위는 매기지 않음), 확정을 해제하기 전까지 경기를 수정할 수 없습니다.',
        reopen: '결과 확정을 해제하시겠습니까?\n저장된 순위·전적 기록이 삭제되고 대진표를 다시 수정할 수 있습니다.',
      },
      alerts: {
        saved: '대진표가 저장되었습니다.',
        finalized: '결과가 확정되었습니다. 회원 대회기록에 반영되었습니다.',
      },
    },
    public: {
      title: '토너먼트 대진표',
      desc: '대회를 선택하면 대진표와 경기 결과를 볼 수 있습니다. 경기 결과는 자동으로 갱신됩니다.',
      loading: '대진표를 불러오는 중...',
      empty: '아직 공개된 대진표가 없습니다.',
    },
    display: {
      defaultTitle: '토너먼트 대진표',
      noTournament: '토너먼트 관리 페이지에서 대회를 선택한 뒤 전광판을 열어 주세요.',
      fullscreen: '전체 화면',
    },
  },
  en: {
    selector: {
      title: 'Select tournament',
    },
    selectPrompt: 'Select a tournament to see its bracket.',
    errors: {
      noTournaments: 'No tournaments have been registered.',
      loadTournaments: 'Could not load the tournament list.',
      noParticipants: 'There are no participants to build a bracket with.',
      loadParticipants: 'Could not load the participant list.',
      loadBracket: 'Could not load the bracket.',
      saveBracket: 'Could not save the bracket.',
      startMatch: 'Could not start the match.',
      endMatch: 'Could not end the match.',
      finalize: 'Could not finalize the results.',
      reopen: 'Could not reopen the results.',
    },
    meta: {
      date: 'Date',
      venue: 'Venue',
      format: 'Format',
      event: 'Event',
      eventName: 'Virtual Taekwondo',
      status: 'Status',
      finished: 'Results finalized',
      inProgress: 'In progress',
    },
    mode: {
      single: 'Single elimination',
      gender: 'Split by gender',
      height: 'Split by height',
      matches: '1:1 matches',
      matchesGender: '1:1 matches (by gender)',
      matchesHeight: '1:1 matches (by height)',
    },
    stats: {
      total: 'Total participants',
      maleFemale: 'Male / Female',
      avgHeight: 'Average height',
      gyms: 'Gyms',
      gymCount: '{count}',
    },
    admin: {
      title: 'Tournament management',
      descBefore:
        'Admin screen for editing brackets, entering match scores and finalizing results. The public page is',
      descAfter: '.',
      selectedTournament: 'Selected tournament',
      loadingParticipants: 'Loading participants...',
      loadingBracket: 'Loading the saved bracket...',
      notEnoughParticipants: 'At least 2 participants are needed to create a bracket. (Currently {count})',
      participantDiffNotice: ({ added, removed }) =>
        `The participants differ from the saved bracket (${added} new / ${removed} withdrawn). ` +
        'To add new participants to the bracket, click "Reset bracket".',
      participantDiffNoticeMatches: ({ added, removed }) =>
        `The participants differ from the saved matches (${added} new / ${removed} withdrawn). ` +
        'To create matches for new participants, use "Auto-pair" or "Add match" in "Edit bracket".',
      hint: {
        edit: 'Choose a bracket format, and click two first-round participants in turn to swap their positions.',
        editMatches:
          'For each match you can change the players, move it up or down, or remove it. A student may play more than once.',
        finished:
          'Results are finalized and recorded in member tournament history. To make changes, click "Reopen".',
        default:
          'Use "Enter score" to record head, body and final scores and the winner of each match. You can also click a player to just pick the winner.',
      },
      saveState: {
        saving: 'Saving...',
        saved: 'Saved',
        synced: 'Applied results received from elsewhere (e.g. a VR device)',
      },
      buttons: {
        resultsFinalized: 'Results finalized',
        reopen: 'Reopen',
        openDisplay: 'Open display board',
        editBracket: 'Edit bracket',
        resetBracket: 'Reset bracket',
        resetMatches: 'Re-pair automatically',
        finalize: 'Finalize results',
        finalizing: 'Finalizing...',
      },
      finalizeDisabledTitle: 'You can finalize once every division has a Final winner.',
      finalizeDisabledTitleMatches:
        'You can finalize once every match has a winner. (Remove matches that will not be played.)',
      editBanner: 'Edit mode · Click participants to reorder round 1',
      editBannerMatches: 'Edit mode · Editing the list of 1:1 matches',
      editBannerSelectSecond: ' (select the second participant)',
      formatGroupLabel: 'Match format',
      formatOptions: {
        tournament: 'Tournament',
        matches: '1:1 matches (multiple)',
      },
      modeGroupLabel: 'Bracket format',
      modeOptions: {
        combined: 'Combined',
        gender: 'Split by gender',
        height: 'Split by height',
      },
      scoreModalTitle: 'Match {no} · {round}',
      confirm: {
        switchLiveMatch: 'End the match in progress on Court {court} (Match {no}, {round}) and start this match?',
        endLiveMatch:
          'End the match on Court {court}? The VR device will no longer be able to send scores for it. (Scores already entered are kept.)',
        changeMode:
          'Changing the bracket format will regenerate the bracket and reset all progress.\nDo you want to continue?',
        changeFormat:
          'Changing the match format will regenerate the bracket and reset all progress.\nDo you want to continue?',
        resetMatches:
          'The 1:1 matches will be paired again automatically. The current match list and all scores and results will be cleared.\nDo you want to continue?',
        reset:
          'Resetting the bracket will randomly reassign the first-round pairings and clear all recorded winners.\nDo you want to continue?',
        finalize:
          'Finalize the bracket results?\nRankings and records will be saved to member tournament history, and the bracket cannot be edited until it is reopened.',
        finalizeMatches:
          'Finalize the match results?\nEach player\'s record and scores will be saved to member tournament history (no rankings), and the matches cannot be edited until they are reopened.',
        reopen:
          'Reopen the results?\nSaved rankings and records will be deleted and the bracket can be edited again.',
      },
      alerts: {
        saved: 'Bracket saved.',
        finalized: 'Results finalized and recorded in member tournament history.',
      },
    },
    public: {
      title: 'Tournament bracket',
      desc: 'Select a tournament to see its bracket and match results. Results update automatically.',
      loading: 'Loading the bracket...',
      empty: 'No bracket has been published yet.',
    },
    display: {
      defaultTitle: 'Tournament bracket',
      noTournament: 'Select a tournament on the tournament management page, then open the display board.',
      fullscreen: 'Full screen',
    },
  },
};

export default tournament;
